<template>
  <div ref="layout" v-loading="loading" class="page-form">
    <h3 class="title">经销商发票冻结</h3>
    <affix v-if="!isEdit">
      <div class="tools">
        <form-button name="保存" type="primary" @click="saveData" />
      </div>
    </affix>

    <div class="form-container">
      <el-form inline size="mini" label-width="100px" :model="conditions" :disabled="isEdit" :rules="rules">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="申请人">
              <el-input
                v-model="conditions.createdByName"
                placeholder="自动生成"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="申请人部门">
              <el-input
                v-model="conditions.department"
                placeholder="请输入"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="申请日期">
              <el-input
                v-model="conditions.createdDate"
                placeholder="请输入"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="所属营销中心">
              <el-select v-model="conditions.saleCenter" placeholder="请选择" clearable>
                <el-option
                  v-for="item in saleList"
                  :key="item.zzfld00001h"
                  :value="item.zzfld00001h"
                  :label="item.mc_short"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="经销商">
              <wly-input
                v-model="conditions.customerCode"
                input-type="customer"
                @enter="handleEnter"
                @handleSuffixClick="openDialog($event, '客户选择')"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="经销商名称">
              <el-input
                v-model="conditions.customerName"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="冻结数量合计">
              <el-input type="text" :value="sum" clearable disabled />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="明细" :custome-config="() => vxeShowCustom('xTable')">
        <template #button>
          <table-button name="add" tip="增加" @click="tableEvent('add')" />
          <table-button name="delete" tip="删除" @click="tableEvent('del')" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :edit-rules="validRules"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <!-- <template #toolbar /> -->
          <template v-for="item in gridOptions.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <el-input
                v-if="gridOptions.columnsFieldTypes[item.field] == 'input'"
                v-model="row[item.field]"
                :disabled="isEdit"
                size="mini"
              />
              <el-select
                v-else-if="
                  gridOptions.columnsFieldTypes[item.field] == 'select' && item.field === 'planType'
                "
                v-model="row[item.field]"
                :disabled="isEdit"
                size="mini"
                @change="optionChange($event,row)"
              >

                <el-option
                  v-for="items in selectDataOptions['A0002']"
                  :key="items.value"
                  :label="items.name"
                  :value="items.value"
                />
              </el-select>
              <el-select
                v-else-if="
                  gridOptions.columnsFieldTypes[item.field] == 'select' &&
                    item.field === 'stockType'
                "
                filterable
                v-model="row[item.field]"
                :disabled="isEdit"
                size="mini"
                @change="optionChange($event,row)"
              >

                <el-option
                  v-for="items in selectDataOptions['A0019']"
                  :key="items.value"
                  :label="items.name"
                  :value="items.value"
                />
              </el-select>
              <el-select
                v-else-if="
                  gridOptions.columnsFieldTypes[item.field] == 'select' &&
                    item.field === 'invoiceNature'
                "
                v-model="row[item.field]"
                :disabled="isEdit"
                size="mini"
              >
                <el-option
                  v-for="items in selectDataOptions['A0032']"
                  :key="items.value"
                  :label="items.name"
                  :value="items.value"
                />
              </el-select>
              <span v-else>{{ row[item.field] }}</span>
            </div>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <org-select v-if="dialogTitle === '营销中心'" ref="dialogSelect" />

        <client-select v-if="dialogTitle === '客户选择'" ref="dialogSelect" />
      </template>

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="submitHandle"
        >确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import {
  saveInvoiceFreeze,
  findInvoiceFreezeById,
  findInvoiceRemainQty,
  deleteInvoiceFreezeSub
} from '@/api/applyForGoods/index'
import { mapGetters } from 'vuex'
import { apiGetOrgOrBase } from '@/api/sap/common-sap'
const ClientSelect = () => import('@/components/dialog/ClientSelect.vue')
const OrgSelect = () => import('@/components/dialog/OrgSelect.vue')
export default {
  components: {
    ClientSelect,
    OrgSelect
  },
  data() {
    const rules = {
      customerName: [{ required: true, message: '请选择经销商', trigger: 'change' }]
    }
    return {
      rules,
      showDialog: false,
      dialogTitle: '客户选择',
      loading: false,
      id: '',
      conditions: {
        saleCenter: '',
        saleCenterView: '',
        customerCode: '',
        customerName: '',
        department: '',
        createdByName: '',
        createdDate: ''
      },
      validRules: {
        planType: [
          { required: true, message: '请选择计划类型', trigger: 'change' }
        ]
      },
      selectDataOptions: {
        province: [],
        city: [],
        saleCenter: []
      },
      saleList: [],
      gridOptions: {
        buttons: [
          {
            label: '新增',
            type: 'add',
            icon: 'icon-add',
            style: 'primary'
          },
          {
            label: '删除',
            type: 'delete',
            icon: 'icon-delete',
            style: 'default'
          }
        ],
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          { field: 'stockType', title: '存货分类', slots: { default: 'stockType' }},
          { field: 'planType', title: '*计划类型', slots: { default: 'planType' }},
          { field: 'invoiceNature', title: '发票性质', slots: { default: 'invoiceNature' }},
          { field: 'leftQuantity', title: '开票剩余量', slots: { default: 'leftQuantity' }},
          { field: 'freezeQuantity', title: '冻结数量', slots: { default: 'freezeQuantity' }},
          { field: 'createdDate', title: '操作日期', slots: { default: 'createdDate' }},
          { field: 'remark', title: '备注', slots: { default: 'remark' }}
        ],
        data: [],
        columnsFieldTypes: {
          stockType: 'select',
          planType: 'select',
          invoiceNature: 'select',
          freezeQuantity: 'input',
          remark: 'input'
        }
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    sum() {
      const sum = this.gridOptions.data.reduce((p, c) => {
        return +c.freezeQuantity + p
      }, 0)
      return sum
    },
    isEdit() {
      return this.conditions.status === 1
    }
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
      this.initDetail()
    } else {
      this.conditions.createdDate = this.$utilsCommon.parseTime(new Date().getTime(), '{y}-{m}-{d}')
      this.conditions.createdByName = this.userInfo.name
      this.conditions.department = this.userInfo.deptName
    }
    this.getSelectDictDataOrigin('A0019')
    this.getSelectDictDataOrigin('A0032')
    this.getSelectDictDataOrigin('A0002')
  },
  methods: {
    initDetail() {
      this.loading = true
      findInvoiceFreezeById({ id: this.id })
        .then(res => {
          if (res?.status === 1) {
            Object.assign(this.conditions, res.data)
            this.gridOptions.data = res.data.list
          }
        })
        .catch(() => (this.loading = false))
        .finally(() => (this.loading = false))
    },
    saveData() {
      this.loading = true
      const params = {
        ...this.conditions,
        list: this.gridOptions.data
      }
      let flag = '0'
      this.gridOptions.data.forEach(item => {
        if (item.planType === '') {
          flag = '1'
        }
      })
      if (flag === '1') {
        this.$message.warning('必须选择计划类型！')
        this.loading = false
      } else {
        saveInvoiceFreeze(params)
          .then(res => {
            if (res?.status === 1) {
              this.gridOptions.data = res.data.list
              Object.assign(this.conditions, res.data)
              this.$message.success('操作成功！')
            }
          })
          .catch(() => (this.loading = false))
          .finally(() => (this.loading = false))
      }
    },
    async optionChange(e, row) {
    //  alert(obj.planType)
    //  console.log("b=_X_ID==",row._XID)
      // row.stockType,row.planType
    //  this.conditions.customerCode='0050000215'
      this.conditions.planType = row.planType
      const params = { ...this.conditions, ...this.pagination }
      const res = await findInvoiceRemainQty(params)
      // console.log("b=res==",res.data)

      this.gridOptions.data.forEach(item => {
      //  console.log("b===",item)
        if (item._XID === row._XID) {
          this.$set(item, 'leftQuantity', res.data)
        }
      })
    },
    openDialog(e, title) {
      e.target.blur()
      this.showDialog = true
      this.dialogTitle = title
    },
    // 控件回车
    async handleEnter(e, type, data) {
      if (typeof type === 'object') {
        this.errorList ? (this.errorList = [type.message]) : this.$message.error(type.message)
        return
      }
      if (!data) return
      this.saleList = data.orgList
      this.conditions.customerCode = data.customerCode
      this.conditions.customerName = data.customerName
      this.conditions.saleCenter = data.orgList[0].zzfld00001h
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()

      if (!data) return

      if (this.dialogTitle === '客户选择') {
        this.conditions.customerCode = data.customerCode
        this.conditions.customerName = data.customerName
        this.saleList = data.orgList
        this.conditions.saleCenter = data.orgList[0].zzfld00001h
      } else {
        this.conditions.saleCenter = data.code
        this.conditions.saleCenterView = data.name
      }
      this.showDialog = false
    },
    tableEvent(btn) {
      if (btn === 'add') {
        this.insertData()
      } else {
        this.removeData()
      }
    },
    insertData() {
      const data = {
        id: '',
        stockType: '',
        leftQuantity: '',
        createdDate: this.$utilsCommon.parseTime(new Date().getTime(), '{y}-{m}-{d}'),
        planType: '',
        invoiceNature: '',
        freezeQuantity: ''
      }
      this.gridOptions.data.unshift(data)
    },
    async removeData() {
      const checkedList = this.$refs.xTable.getCheckboxRecords()
      const hasIds = checkedList.filter(v => v.id)

      if (hasIds.length) {
        const ids = hasIds.map(v => v.id).join(',')
        await deleteInvoiceFreezeSub({ ids })
      }
      checkedList.forEach(item => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/invoiceFreezeAndRelease.vue